export default __webpack_public_path__ + "static/media/Crescents_08.70ab9449.png";